// actionTypes.js
export const GET_ALL_HR_EXPENSES = 'GET_ALL_HR_EXPENSES'
export const HANDLE_EXPENSES_PAGINATION = 'HANDLE_EXPENSES_PAGINATION'
export const HANDLE_APPROVED_EXPENSES = 'HANDLE_APPROVED_EXPENSES'
export const HANDLE_EXPENSE_CATAGORIES = 'HANDLE_EXPENSE_CATAGORIES'
export const HANDLE_EXPENSES_TOTALPRICE = 'HANDLE_EXPENSES_TOTALPRICE'
export const EXPENSES_DOC_CATEGORIES = 'EXPENSES_DOC_CATEGORIES'
export const EXPENSES_ID_DOC = 'EXPENSES_ID_DOC'
